import moment from "moment";

export const reformatDate = (date) => {
    if (!date) {
        return "";
    }
    return moment(date).format("DD.MM.YYYY");
};

export const reformatDateForServer = (date) => {
    const [day, month, year] = date
        .trim()
        .split(".")
        .map((i) => i.trim());

    return `${year}-${month}-${day}`;
};

export const calculateDaysFromNowTo = (date) => {
    const today = moment();
    const dayOfStatusChange = moment(reformatDateForServer(date));
    return today.diff(dayOfStatusChange, "days");
};
